import type { FreightLinkingOptionsResponse } from '@/api/useFreightAssessorials/types'
import { Form, type FormInstance, Select } from 'antd'
import type { FormValues as AutomaticFormValues } from '../tabs/AutomaticAccessorials/components'
import type { FormValues as ManualFormValues } from '../tabs/ManualAccessorials/CreateAccessorialForm'
import { Horizontal } from '@gravitate-js/excalibrr'

const linkedSpecialPayTypeOptions = [
  { label: 'Freight Line Item → Special Pay', value: 'create_special_pay' },
  { label: 'Special Pay → Freight Line Item', value: 'create_line_item' },
  { label: 'Freight Line Item ↔ Special Pay', value: 'bidirectional' },
]

type FreightLinkingOptionsSelectProps = {
  form: FormInstance<ManualFormValues> | FormInstance<AutomaticFormValues> | undefined
  specialPayOptions: FreightLinkingOptionsResponse['data']
  bookType?: string
  isManual?: boolean
}

export function FreightLinkingOptionsSelect({
  form,
  specialPayOptions,
  bookType,
  isManual,
}: FreightLinkingOptionsSelectProps) {
  if (!form) return null
  return (
    <Form.Item
      shouldUpdate={(prev, curr) =>
        prev.link_to_special_pay !== curr.link_to_special_pay || prev.fee_type !== curr.fee_type
      }
      noStyle
    >
      {() => {
        const showSpecialPay = form.getFieldValue?.('link_to_special_pay')
        const feeType = form.getFieldValue?.('fee_type')
        return showSpecialPay ? (
          <Horizontal gap={8} className='px-2'>
            <Form.Item
              label='Select Driver Special Pay Item'
              name='linked_special_pay_config'
              rules={[{ required: true, message: 'Please select a special pay item' }]}
              className='flex-1'
            >
              <Select
                labelInValue
                options={specialPayOptions
                  .filter((option) => option.fee_types?.includes(feeType))
                  .map((option) => ({
                    label: option.name,
                    value: option.id,
                  }))}
                notFoundContent={
                  feeType
                    ? 'No options available for selected fee type.'
                    : 'Select a fee type to see available options.'
                }
              />
            </Form.Item>
            {isManual && (
              <Form.Item
                label='Select Link Type'
                name={'link_type'}
                rules={[{ required: true, message: 'Please select a link type' }]}
                className='flex-1'
              >
                <Select
                  options={
                    bookType === 'Cost'
                      ? linkedSpecialPayTypeOptions.filter((option) => option.value === 'create_special_pay')
                      : linkedSpecialPayTypeOptions
                  }
                />
              </Form.Item>
            )}
          </Horizontal>
        ) : null
      }}
    </Form.Item>
  )
}
